import { FacilityId } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import { SWRConfiguration } from 'swr'

export const useFacilityTimetables = (
  facilityId: FacilityId,
  config?: SWRConfiguration,
) => {
  const client = useGyymClient()
  return useGyymSWR([client.user.facilities.listTimetables, facilityId], config)
}
